import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function EmpathySection() {
  const t = useT().empathy;
  return <Section hasOrb={false} data-id="element-36">
      <div className="max-w-3xl" data-id="element-37">
        <Kicker data-id="element-38">{t.kicker}</Kicker>
        <H2 data-id="element-39">{t.title}</H2>

        <div className="space-y-6 text-lg sm:text-xl text-ink-dim leading-relaxed" data-id="element-40">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-41">
            {t.p1}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-42">
            {t.p2}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.01
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="text-ink font-medium" data-id="element-43">
            {t.p3}
          </motion.p>
        </div>
      </div>
    </Section>;
}